import { FormControlState } from "@angular/forms";

export type FormInitialState<T> = T | FormControlState<T>;

export function isFormControlState<T>(obj: unknown): obj is FormControlState<T>
{
    return !!obj && typeof obj === "object" && "value" in obj;
}
